window.Overview = function () {
    /************ SENSING ************/
    const $sensing = $('.CarrouselSensing');
    $sensing.on('init', () => $sensing.css('visibility', 'visible'));
    $sensing.slick({
        lazyLoad: 'ondemand',
        slidesToShow: 3,
        dots: true,
        arrows: false,
        infinite: false,
        swipe: true,
        responsive: [
            { breakpoint: 769, settings: { slidesToShow: 2, dots: true } },
            { breakpoint: 450, settings: { slidesToShow: 1, dots: true } }
        ]
    });

    // crea / asegura los botones
    const sensingEnsureNav = () =>
        ensureNav($sensing, 'Buttons-Sensing', 'PrevSensing', 'NextSensing');
    $sensing.on('init reInit setPosition breakpoint', sensingEnsureNav);
    sensingEnsureNav();


    /************ COMPARE ************/
    const $compare = $('.CarrouselCompare');
    $compare.on('init reInit afterChange', (e, slick) => {
        if (slick.slideCount < 3) $compare.addClass('noPadRight');
        $compare.css('visibility', 'visible');
    });
    $compare.slick({
        lazyLoad: 'ondemand',
        dots: true,
        arrows: false,
        infinite: false,
        slidesToShow: 3,
        responsive: [
            { breakpoint: 769, settings: { slidesToShow: 2 } },
            { breakpoint: 768, settings: { slidesToShow: 1 } }
        ]
    });

    const compareEnsureNav = () =>
        ensureNav($compare, 'Buttons-Compare', 'PrevCompare', 'NextCompare');
    $compare.on('init reInit setPosition breakpoint', compareEnsureNav);
    compareEnsureNav();


    /************ GALLERY (igual que tenías) ************/
    const $gallery = $('.GalleryContent');
    $gallery.on('init reInit afterChange', (e, slick) => {
        if (slick.slideCount < 3) $gallery.addClass('noPadRight');
    });
    const gallerySettings = {
        dots: true,
        arrows: false,
        infinite: false,
        slidesToShow: 3,
        responsive: [
            { breakpoint: 99999, settings: 'unslick' },
            { breakpoint: 1024,  settings: { slidesToShow: 2 } },
            { breakpoint: 767,   settings: { slidesToShow: 1 } }
        ]
    };
    $gallery.slick(gallerySettings);
    $(window).on('resize', () => {
        if (!$gallery.hasClass('slick-initialized')) $gallery.slick(gallerySettings);
    });
    const galleryEnsureNav = () =>
        ensureNav($gallery, 'Buttons-Gallery', 'PrevGallery', 'NextGallery');
    $gallery.on('init reInit setPosition breakpoint', galleryEnsureNav);
    galleryEnsureNav();


    /************ MENÚ CAR (sin cambios) ************/
    $('#carMenu').on('click', 'li a', function () {
        $('#carMenu li a').removeClass('active');
        $(this).addClass('active');
    });


    /************ Helper sin duplicados ************/
    function ensureNav($container, wrapperClass, prevClass, nextClass) {
        if (!$container.length || !$container.hasClass('slick-initialized')) return;

        // dots (los regenera Slick a veces) – buscamos los del contenedor actual
        let $dots = $container.children('.slick-dots');
        if (!$dots.length) $dots = $container.find('> .slick-dots'); // fallback
        if (!$dots.length) return;

        // ¿ya hay wrapper?
        let $wrapper = $container.children('.' + wrapperClass);

        // si no hay wrapper, crearlo y mover dentro los dots actuales
        if (!$wrapper.length) {
            $dots.wrap('<div class="' + wrapperClass + ' ButtonsCarrousel"></div>');
            $wrapper = $container.children('.' + wrapperClass);
        } else {
            // si el wrapper existe pero por reInit los dots quedaron fuera, muévelos
            if (!$wrapper.find('.slick-dots').length) $wrapper.append($dots);
            // elimina wrappers duplicados dentro del mismo contenedor (por si quedaron)
            $container.children('.' + wrapperClass).not($wrapper).remove();
        }

        // crea botones solo si no existen dentro del wrapper
        if (!$wrapper.find('.' + prevClass).length) {
            $wrapper.prepend('<div class="Prev ' + prevClass + '"><i class="fas fa-chevron-left"></i></div>');
        }
        if (!$wrapper.find('.' + nextClass).length) {
            $wrapper.append('<div class="Next ' + nextClass + '"><i class="fas fa-chevron-right"></i></div>');
        }

        // asegura 1 solo handler por wrapper usando namespace
        $wrapper.off('.nav');
        $wrapper.on('click.nav', '.' + prevClass, () => $container.slick('slickPrev'));
        $wrapper.on('click.nav', '.' + nextClass, () => $container.slick('slickNext'));
    }
};
